import axios from "axios";

const api = axios.create({
  baseURL: "https://eic-general-api.azurewebsites.net/",
});

export default api;